import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getSleeve } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class SleeveContainer extends React.Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.request(id);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.props.request(this.props.id);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || [];
    const { sleeve, next, previous } = result;
    if (loading) {
      return (
        <div className="page-sleeve">
          <div className="sleeve-main-wrap">
            <div className="sleeve-main-skeleton">
              <Skeleton width="100%" height="100%" />
            </div>
          </div>
          <Skeleton count={2} />
        </div>
      );
    }
    if (!loading && sleeve.length === 0) {
      return null;
    }
    return render({ sleeve, next, previous, loading, failure });
  };
}

export default CreateContainer(getSleeve, SleeveContainer);
